<template>
<!--  首页-->
  <div id="myHome" v-if="userMenu.indexOf('数据上传') >= 0">
    <div class="allBody">
      <!-- <nav class="allTop">
        <img src="../../../assets/home01.png" width="100%" height="60"/>
        <div>数据上传</div>
      </nav> -->
      <div>
        <div class="allDl m_t_20">
          <dl class="allDl_width20 allDl_span60">
            <dd>
              <span>文件名:</span>
              <div>
                <input v-model="postData.FileName" type="text" class="allInput"/>
              </div>
            </dd>
            <dd>
              <span>部门:</span>
              <div>
                <input v-model="postData.BU" type="text" class="allInput"/>
              </div>
            </dd>
            <dd>
              <span>归属类别:</span>
              <div>
                <input v-model="postData.ProjectBelong" type="text" class="allInput"/>
              </div>
            </dd>
            <dd>
              <span>频率:</span>
              <div>
                <allSelect v-model="postData.UploadFrequency" :chooseData="frequencyType" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
                </allSelect>
              </div>
            </dd>
            <dt style="width: auto">
              <button @click="getAllSerch()" class="suerButton"><i class="icon iconfont iconsousuo" style="font-size: 14px"></i><span class="m_l_5">搜索</span></button>
            </dt>
          </dl>
        </div>
        <div class="m_t_20 m_b_5">
          <ul class="d_flex" style="justify-content: flex-start">
            <li class="m_r_10">
              <img src="../../../assets/upWait01.png" height="12" width="12"/>
              <span>待上传：{{ myPending.pendingCount }}</span>
            </li>
            <li class="m_r_10">
              <img src="../../../assets/upWait02.png" height="12" width="12"/>
              <span>已上传：{{ myPending.processedCount }}</span>
            </li>
            <li>
              <img src="../../../assets/upWait03.png" height="12" width="12"/>
              <span>不定期：{{ myPending.otherCount }}</span>
            </li>
          </ul>
        </div>
        <div style="max-height: calc(100vh - 240px);overflow: auto">
          <table class="allTable" cellspacing="0">
            <thead>
            <tr>
              <th style="text-align: left">文件名</th>
              <th>部门</th>
              <th>归属类别</th>
              <th>频率</th>
              <th>上传方式</th>
              <th>最后上传时间</th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr :key="index" v-for="(item, index) in myAllList">
              <td style="text-align: left">
                <span :class="['tag-wait',returnPending(item.pendType)]">{{item.pendType | getWaitText}}</span>
                <span class="NoWrap dis_line" style="vertical-align: text-bottom;max-width: 300px" :title="item.fileName">{{ item.fileName }}</span>
              </td>
              <td>{{ item.bu }}</td>
              <td>{{ item.projectBelong }}</td>
              <td>
                <span v-if="item.uploadFrequency === 'Monthly'">每月</span>
                <span v-if="item.uploadFrequency === 'Annually'">每年</span>
              </td>
              <td>{{ item.uploadMethod }}</td>
              <td>{{$commonJs.returnDate(item.lastModificationTime, 'YYMMDD')}}</td>
              <td class="colorYellowF36A20" width="120">
                <div class="d_flex">
                  <div style="width: 16px">
                    <span class="c_p" v-if="item.isEnableDownload" @click="confirmExport(item)" title="下载">下载</span>
                  </div>
                  <div style="width: 16px">
                    <span class="c_p" v-if="item.uploadMethod === 'Portal' && item.isEnableUpload" @click="openUpFile(item)" title="上传">上传</span>
                  </div>
                  <div style="width: 50px">
                    <span class="c_p" @click="toUrl('myUpHistoryRecord', item)">查看记录</span>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <page :totalCount="totalCount" v-if="totalPage !== 0" v-on:on-getList="getAllList($event)" :totalPage="totalPage" :page="page" :numPage="1"></page>
      </div>
    </div>
    <model v-if="showModel" :title="showTitle" :minWidth="'40%'" :showClose="showClose" :onButton="0" v-on:on-cancel="UpfCancl(1)">
      <div class="m_t_20">
        <div v-if="showFile === 1" class="fileDiv">
          <section class="m_b_20" v-if="showMidPath">
            <p class="font14 m_b_10">选择日期</p>
            <div class="d_flex" style="justify-content: flex-start">
              <div class="m_r_10" style="width: 100px">
                <allSelect v-on:on-change="changeTime($event)" v-model="seltFyear" :chooseData="fileYear" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
                </allSelect>
              </div>
              <div style="width: 100px" v-if="showMidPath === 'yyyymm'">
                <allSelect v-on:on-change="changeTime($event)" v-model="seltFmouth" :chooseData="fileMouth" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
                </allSelect>
              </div>
            </div>
          </section>
          <div style="height: 240px">
            <section class="m_b_10"><i class="el-icon-upload icon-upload"></i></section>
            <section>
              <input @change="allUpFileH($event)" type="file" class="numUpFile" id="numUpFile"/>
              <label for="numUpFile">选择文件</label>
            </section>
          </div>
          <section v-if="parseInt(myNewFile.id) !== 0" class="fileProgDiv p_t_b_15" style="width: 100%">
            <div>
              <p class="font14 m_b_10">已有文件</p>
              <div class="d_flex">
                <div class="filTyDiv">
                  <span class="up01"></span>
                  <div v-if="myNewFile.extension.indexOf('xls') >= 0">xlsx</div>
                  <div v-if="myNewFile.extension.indexOf('csv') >= 0">CSV</div>
                </div>
                <div class="filrProgNum">
                  <p class="d_flex">
                    <span class="font14">{{ myNewFile.fileName }}</span>
                    <span class="colorGray9D9D9D">100k</span>
                  </p>
                  <p class="colorGray9D9D9D">上传时间：{{ myNewFile.createTime }}</p>
                </div>
                <div style="visibility: hidden">
                  <i class="icon iconfont iconguanbi1 colorGray9D9D9D"></i>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div v-if="showFile === 2" class="fileProgDiv">
          <div>
            <p class="font14 m_b_10">上传文件</p>
            <div class="d_flex">
              <div class="filTyDiv">
                <img src="../../../assets/uP01.png" height="61" width="48"/>
                <div>xlsx</div>
              </div>
              <div class="filrProgNum">
                <p class="d_flex">
                  <span>文件名</span>
                  <span class="colorGray9D9D9D">{{ uploadPercent }}%</span>
                </p>
                <div class="m_t_5 m_b_5">
                  <div :style="{'width': uploadPercent + '%'}"></div>
                </div>
                <p class="colorGray9D9D9D">{{ upFileSize }}K</p>
              </div>
              <div style="visibility: hidden">
                <i class="icon iconfont iconguanbi1 colorGray9D9D9D"></i>
              </div>
            </div>
            <div class="p_t_b_15 t_c f_w font14">{{ formEro.formEroFileNameFist }}</div>
          </div>
        </div>
      </div>
    </model>
    <model v-if="showModel2" :title="showTitle2" :minWidth="showUpType === 4 ? '70%' : '40%'" :onButton="0" v-on:on-cancel="UpfCancl(2)">
      <div class="pd_10_20">
        <div class="t_c" v-if="showUpType === 1">
          <img v-if="absoluteError === 1" src="../../../assets/model02.png" height="86" width="86"/>
          <img v-if="absoluteError === 2" src="../../../assets/model04.png" height="86" width="86"/>
          <p v-if="absoluteError === 2" class="font18 f_w m_t_20 Newline p_L_10 p_r_10">上传失败：{{ upTypeName }}</p>
          <p v-if="absoluteError === 1" class="m_t_20 font18 f_w">{{ upTypeName }}</p>
          <!--<p class="m_t_20 font18 f_w" :class="upTypeName === '上传成功' ? 'font18 f_w' : 'font16'">{{ upTypeName }}</p>-->
          <div  v-if="absoluteError !== 1" class="t_c m_t_20">
            <button  @click="UpfCancl(2)" class="suerButton m_r_10 m_l_10"><span>确定</span></button>
          </div>
        </div>
        <div v-if="showUpType === 2">
          <div class="t_c">
            <img src="../../../assets/model03.png" height="86" width="86"/>
            <p class="font18 f_w m_t_20">{{ formEro.formEroFileNameFist }}</p>
          </div>
          <div class="t_c m_t_20">
            <button @click="UpfCancl(3)" class="suerButton m_r_10 m_l_10"><span>确定</span></button>
          </div>
        </div>
        <div v-if="showUpType === 3">
          <div class="t_c">
            <img src="../../../assets/model04.png" height="86" width="86"/>
            <p class="font18 f_w m_t_20">上传失败</p>
            <p class="m_t_5" style="color: #848484">文件名错误，请重新上传，如果不上传，则保存不成功。</p>
          </div>
          <div class="t_c m_t_20">
            <button class="suerButton m_r_10 m_l_10"><span>确定</span></button>
          </div>
        </div>
        <div v-if="showUpType === 4">
          <div class="t_c">
            <img src="../../../assets/model04.png" height="86" width="86"/>
            <p v-if="myErroerList.length > 0" class="font18 f_w m_t_5">上传失败，请重新上传，如果不上传，则保存不成功。</p>
            <p v-if="myErroerList.length === 0" class="font18 f_w m_t_20">上传失败: {{ formEro.formEroName }}</p>
            <!--<p v-if="myErroerList.length === 0" class=" m_t_5 Newline m_b_10 font18 f_w">{{ formEro.formEroName }}</p>-->
            <!--<p v-if="myErroerList.length === 0" class=" m_t_5 Newline m_b_10" :class="myErroerList.length === 0 ? 'font16' : 'font18 f_w'">{{ formEro.formEroName }}</p>-->
            <div v-if="myErroerList.length === 0" class="t_c m_t_20">
              <button  @click="UpfCancl(4)" class="suerButton m_r_10 m_l_10"><span>确定</span></button>
            </div>
          </div>
          <div style="padding-top: 20px;border-top: 1px solid #F36A20" class="m_t_20" v-if="myErroerList.length > 0">
            <div style="max-height: 40vh;overflow: auto; ">
              <table class="allTable" cellspacing="0">
                <thead>
                <tr>
                  <th>Sheet名</th>
                  <th>行号</th>
                  <th>列名</th>
                  <th>所填内容</th>
                  <th>错误信息</th>
                </tr>
                </thead>
                <tbody>
                <tr :key="index" v-for="(item, index) in myErroerList">
                  <td>{{ item.sheetName }}</td>
                  <td>{{ item.rowNumber }}</td>
                  <td>{{ item.columnName }}</td>
                  <td><span class="Newline dis_line" style="max-width: 500px">{{ item.content }}</span></td>
                  <td>{{ item.summary }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <p class="t_r">
              <span class="colorYellowF36A20 font14 f_w c_p" @click="toUrl('myErrorMessageList', '')"><abbr>查看更多</abbr><i class="icon iconfont iconshuangjiantouyou"></i></span>
            </p>
          </div>
          <div class="t_c m_t_20" v-if="myErroerList.length > 0">
            <button @click="downEorFile()" class="suerButton m_r_10 m_l_10"><span>下载全部错误信息</span></button>
          </div>
        </div>
      </div>
    </model>
    <model v-if="showModel4" :title="'正在下载'" :minWidth="'60%'" :showClose="1" :onButton="0" v-on:on-cancel="showModel3 = false">
      <div class="pd_10_20">
        <div class="filrProgNum" style="margin: auto">
          <p class="d_flex">
            <span>{{ upName }}</span>
            <span class="colorGray9D9D9D">{{ uploadMdoel }}%</span>
          </p>
          <div class="m_t_5 m_b_5">
            <div :style="{'width': uploadMdoel + '%'}"></div>
          </div>
        </div>
      </div>
    </model>
  </div>
</template>

<script>
import axios from 'axios'
import avatar from '@/assets/loading.gif'
let timeInever
export default {
  name: 'myHome',
  data () {
    return {
      showModel4: false,
      uploadMdoel: 0,
      upName: '',
      userMenu: this.$userMenu,
      totalPage: 0,
      totalCount: 0,
      page: 1,
      postData: {
        FileName: '',
        BU: '',
        ProjectBelong: '',
        UploadFrequency: 0,
        PageIndex: 1,
        PageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      serchData: {
        FileName: '',
        BU: '',
        ProjectBelong: '',
        UploadFrequency: 0,
        PageIndex: 1,
        PageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      frequencyType: [
        {
          id: 0,
          name: '全部'
        },
        {
          id: 1,
          name: '每月'
        },
        {
          id: 2,
          name: '每年'
        },
        {
          id: 3,
          name: '不定时'
        }
      ],
      showModel: false,
      showTitle: '文件上传',
      showModel2: false,
      showClose: 0,
      showTitle2: '',
      showFile: 2,
      showFUp: 1,
      fileYear: [],
      fileMouth: [],
      seltFyear: '',
      seltFmouth: '',
      showMidPath: '',
      source: '',
      uploadPercent: 0,
      upFileSize: 0,
      myAllList: [],
      upTypeName: '',
      showUpType: 1,
      absoluteError: 1,
      myErroerList: [],
      myNewFile: {
        id: 0,
        fileName: '',
        extension: '',
        createTime: ''
      },
      myNewUpFile: {},
      formEro: {
        formEroId: 0,
        formEroFileName: '',
        formEroName: '',
        formEroFileNameFist: ''
      },
      cutInUp: 1,
      myPending: {
        otherCount: 0,
        pendingCount: 0,
        processedCount: 0
      }
    }
  },
  created () {
    this.seltFyear = new Date().getFullYear()
    for (let i = 1; i < 13; i++) {
      let list = {
        id: i,
        name: i
      }
      this.fileMouth.push(list)
    }
    this.seltFmouth = new Date().getMonth() + 1
    this.getAllNf()
    if (this.userMenu.indexOf('数据上传') >= 0) {
      this.$commonJs.addLog('查看', '数据上传', '', '')
      this.getAllList(1)
    }
    // this.getErrorList()
  },
  mounted () {
  },
  destroyed () {
  },
  filters: {
    getWaitText (type) {
      switch (parseInt(type)) {
        case 1:
          return '待上传'
        case 2:
          return '已上传'
        case 3:
          return '不定期'
        case 4:
          return ''
      }
      return ''
    }
  },
  methods: {
    getAllSerch () {
      this.serchData = JSON.parse(JSON.stringify(this.postData))
      this.getAllList(1)
    },
    getAllList (page) {
      clearInterval(timeInever)
      let data = JSON.parse(JSON.stringify(this.serchData))
      data.PageIndex = page
      let url = this.$commonJs.returnQuery('/api/File/list', data)
      this.$axiox.get(url).then(msg => {
        this.myAllList = msg.datas || []
        this.myPending = {
          otherCount: msg.pending.otherCount,
          pendingCount: msg.pending.pendingCount,
          processedCount: msg.pending.processedCount
        }
        this.page = page
        this.totalPage = Math.ceil(msg.total / this.serchData.PageSize)
        this.totalCount = msg.total
      })
    },
    returnPending (type) {
      switch (parseInt(type)) {
        case 1:
          return 'tag-wait1'
        case 2:
          return 'tag-wait2'
        case 3:
          return 'tag-wait3'
        case 4:
          return ''
      }
      return ''
    },
    // 获取年份
    getAllNf () {
      let nowYear = new Date()
      this.fileYear = []
      let startYear = 2015
      let endYear = nowYear.getFullYear() + 1
      for (let i = startYear; i <= endYear; i++) {
        let list = {
          id: i,
          name: i
        }
        this.fileYear.push(list)
      }
      this.fileYear = this.fileYear.reverse()
    },
    openUpFile (item) {
      this.showClose = 0
      this.showModel = true
      this.showFile = 1
      this.showFUp = 1
      this.myNewUpFile = JSON.parse(JSON.stringify(item))
      this.showMidPath = item.midPath ? item.midPath : ''
      this.getNewLastFile(item.id)
    },
    getNewLastFile (id) {
      let data = {
        itemId: id,
        year: this.showMidPath ? this.seltFyear : 0,
        month: this.showMidPath && this.showMidPath === 'yyyymm' ? this.seltFmouth : 0
      }
      let url = this.$commonJs.returnQuery('/api/File/GetLastFile', data)
      this.$axiox.get(url).then(msg => {
        if (msg.data) {
          this.myNewFile = msg.data
        } else {
          this.myNewFile = {
            id: 0,
            fileName: '',
            extension: '',
            createTime: ''
          }
        }
      })
    },
    changeTime (e) {
      this.getNewLastFile(this.myNewUpFile.id)
    },
    allUpFileH (e) {
      let that = this
      let timePath = ''
      that.uploadPercent = 0
      that.cutInUp = 1
      this.formEro = {
        formEroId: 0,
        formEroFileName: '',
        formEroName: '',
        formEroFileNameFist: ''
      }
      if (this.showMidPath) {
        let mouth = this.seltFmouth < 10 ? '0' + this.seltFmouth : this.seltFmouth
        timePath = this.showMidPath === 'yyyymm' ? this.seltFyear + '' + mouth : this.seltFyear
      }
      let fileData = new FormData()
      let file = e.target.files[0]
      let fileType = file.name.split('.')[file.name.split('.').length - 1]
      if (this.$commonJs.excelUpLoadFileList.indexOf(fileType.toLowerCase()) < 0) {
        this.$commonJs.alertTips({
          type: 'eror',
          title: '错误',
          content: '请选择excel或csv文件',
          stayTime: 5
        })
        e.target.value = ''
        return
      }
      if (this.myNewFile.id === 0) {
        // let that = this
        that.source = axios.CancelToken.source()
        fileData.append('file', file)
        let url = '/api/File/Upload?itemId=' + this.myNewUpFile.id + '&coverid=0&timePath=' + timePath
        this.$axiox.upLoadFile(url, fileData, that.source.token, msg => {
          that.showFile = 2
          let loaded = msg.loaded
          let total = msg.total
          that.$nextTick(() => {
            that.uploadPercent = Math.floor(loaded / total * 100) > 1 ? Math.floor(loaded / total * 100) : 1
            that.upFileSize = parseFloat(loaded / 1024).toFixed(0)
            that.cutInUp = 2
          })
        }).then(p => {
          if (p.isSuccess) {
            this.showClose = parseInt(p.data) > 0 ? 1 : 0
            if (parseInt(that.uploadPercent) >= 100) {
              that.cutInUp = 1
              this.formEro.formEroId = p.data
              this.formEro.formEroFileNameFist = p.message
              if (p.message === '上传成功,正在进行后台校验,请稍等...') {
                this.coverGif()
                timeInever = setInterval(() => {
                  this.$axiox.get('/api/File/checkStatus?hisid=' + parseInt(p.data), '', true).then(msg => {
                    console.log(msg)
                    this.disCover()
                    if (parseInt(msg.message) === 4) {
                      clearInterval(timeInever)
                      this.showModel = false
                      this.showModel2 = true
                      this.showUpType = 4
                      this.absoluteError = 2
                      this.myErroerList = msg.data.errorList || []
                      this.formEro.formEroFileName = msg.data.fileName
                      this.formEro.formEroName = msg.data.errorMessage
                    }
                    if (parseInt(msg.message) === 5) {
                      clearInterval(timeInever)
                      this.showModel = false
                      this.showModel2 = true
                      this.showUpType = 1
                      this.absoluteError = 1
                      this.upTypeName = '上传成功'
                    }
                  })
                }, 2000)
              } else {
                that.cutInUp = 1
                this.showModel = false
                this.showModel2 = true
                this.showUpType = 2
              }
            }
          } else {
            that.cutInUp = 1
            this.showModel = false
            this.showModel2 = true
            this.showUpType = 1
            this.absoluteError = 2
            this.upTypeName = p.message
          }
          e.target.value = ''
        })
      } else {
        this.$commonJs.doubleComfirmFile({
          content: '是否覆盖已有文件',
          successFun: msg => {
            // let that = this
            that.source = axios.CancelToken.source()
            // let fileData = new FormData()
            // let file = e.target.files[0]
            // let fileType = file.name.split('.')[file.name.split('.').length - 1]
            // if (this.$commonJs.excelUpLoadFileList.indexOf(fileType.toLowerCase()) < 0) {
            //   this.$commonJs.alertTips({
            //     type: 'eror',
            //     title: '错误',
            //     content: '请选择excel文件',
            //     stayTime: 5
            //   })
            //   e.target.value = ''
            //   return
            // }
            fileData.append('file', file)
            let url = '/api/File/Upload?itemId=' + this.myNewUpFile.id + '&coverid=' + this.myNewFile.id + '&timePath=' + timePath
            this.$axiox.upLoadFile(url, fileData, that.source.token, msg => {
              that.showFile = 2
              let loaded = msg.loaded
              let total = msg.total
              that.$nextTick(() => {
                that.uploadPercent = Math.floor(loaded / total * 100) > 1 ? Math.floor(loaded / total * 100) : 1
                that.upFileSize = parseFloat(loaded / 1024).toFixed(0)
                that.cutInUp = 2
              })
            }).then(p => {
              if (p.isSuccess) {
                this.showClose = parseInt(p.data) > 0 ? 1 : 0
                if (parseInt(that.uploadPercent) >= 100) {
                  that.cutInUp = 1
                  this.formEro.formEroId = p.data
                  this.formEro.formEroFileNameFist = p.message
                  if (p.message === '上传成功,正在进行后台校验,请稍等...') {
                    this.coverGif()
                    timeInever = setInterval(() => {
                      this.$axiox.get('/api/File/checkStatus?hisid=' + parseInt(p.data), '', true).then(msg => {
                        console.log(msg)
                        this.disCover()
                        if (parseInt(msg.message) === 4) {
                          clearInterval(timeInever)
                          this.showModel = false
                          this.showModel2 = true
                          this.showUpType = 4
                          this.absoluteError = 2
                          this.myErroerList = msg.data.errorList || []
                          this.formEro.formEroFileName = msg.data.fileName
                          this.formEro.formEroName = msg.data.errorMessage
                        }
                        if (parseInt(msg.message) === 5) {
                          clearInterval(timeInever)
                          this.showModel = false
                          this.showModel2 = true
                          this.showUpType = 1
                          this.absoluteError = 1
                          this.upTypeName = '上传成功'
                        }
                      })
                    }, 2000)
                  } else {
                    that.cutInUp = 1
                    this.showModel = false
                    this.showModel2 = true
                    this.showUpType = 2
                  }
                }
              } else {
                that.cutInUp = 1
                this.showModel = false
                this.showModel2 = true
                this.showUpType = 1
                this.absoluteError = 2
                this.upTypeName = p.message
              }
              e.target.value = ''
            })
          },
          errorFun: msg => {
            // let that = this
            that.source = axios.CancelToken.source()
            // let fileData = new FormData()
            // let file = e.target.files[0]
            // let fileType = file.name.split('.')[file.name.split('.').length - 1]
            // if (this.$commonJs.excelUpLoadFileList.indexOf(fileType.toLowerCase()) < 0) {
            //   this.$commonJs.alertTips({
            //     type: 'eror',
            //     title: '错误',
            //     content: '请选择excel文件',
            //     stayTime: 5
            //   })
            //   e.target.value = ''
            //   return
            // }
            fileData.append('file', file)
            let url = '/api/File/Upload?itemId=' + this.myNewUpFile.id + '&coverid=0&timePath=' + timePath
            this.$axiox.upLoadFile(url, fileData, that.source.token, msg => {
              that.showFile = 2
              let loaded = msg.loaded
              let total = msg.total
              that.$nextTick(() => {
                that.uploadPercent = Math.floor(loaded / total * 100) > 1 ? Math.floor(loaded / total * 100) : 0
                that.upFileSize = parseFloat(loaded / 1024).toFixed(0)
                that.cutInUp = 2
              })
            }).then(p => {
              if (p.isSuccess) {
                this.showClose = parseInt(p.data) > 0 ? 1 : 0
                if (parseInt(that.uploadPercent) >= 100) {
                  this.formEro.formEroId = p.data
                  this.formEro.formEroFileNameFist = p.message
                  if (p.message === '上传成功,正在进行后台校验,请稍等...') {
                    that.cutInUp = 1
                    this.coverGif()
                    timeInever = setInterval(() => {
                      this.$axiox.get('/api/File/checkStatus?hisid=' + parseInt(p.data), '', true).then(msg => {
                        console.log(msg)
                        this.disCover()
                        if (parseInt(msg.message) === 4) {
                          clearInterval(timeInever)
                          this.showModel = false
                          this.showModel2 = true
                          this.showUpType = 4
                          this.absoluteError = 2
                          this.myErroerList = msg.data.errorList || []
                          this.formEro.formEroFileName = msg.data.fileName
                          this.formEro.formEroName = msg.data.errorMessage
                        }
                        if (parseInt(msg.message) === 5) {
                          clearInterval(timeInever)
                          this.showModel = false
                          this.showModel2 = true
                          this.showUpType = 1
                          this.absoluteError = 1
                          this.upTypeName = '上传成功'
                        }
                      })
                    }, 2000)
                  } else {
                    that.cutInUp = 1
                    this.showModel = false
                    this.showModel2 = true
                    this.showUpType = 2
                  }
                }
              } else {
                that.cutInUp = 1
                this.showModel = false
                this.showModel2 = true
                this.showUpType = 1
                this.absoluteError = 2
                this.upTypeName = p.message
              }
              e.target.value = ''
            })
          },
          errorFunTwo: msg => {
            this.showModel = false
            e.target.value = ''
          }
        })
      }
    },
    UpfCancl (type) {
      this.showModel = false
      this.showModel2 = false
      if (parseInt(this.cutInUp) === 2) {
        this.source.cancel()
        this.uploadPercent = 0
        this.cutInUp = 1
        if (parseInt(this.uploadPercent) === 0) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '取消上传',
            stayTime: 5
          })
        }
      }
      clearInterval(timeInever)
      if (type !== 1) {
        this.getAllList(this.page)
      }
    },
    toUrl (url, item) {
      if (url === 'myUpHistoryRecord') {
        this.$commonJs.addLog('查看记录', '数据上传', '', item.fileName)
      }
      this.$router.push({
        name: url,
        query: {
          formId: item.id || this.formEro.formEroId
        }
      })
      localStorage.formHomeFileName = item.fileName || this.formEro.formEroFileName
      localStorage.upHistName = item.fileName || this.formEro.formEroFileName
    },
    // 获取错误信息
    getErrorList () {
      let data = {
        hisid: 0,
        PageIndex: 1,
        PageSize: 5
      }
      let url = this.$commonJs.returnQuery('/api/File/GetUploadErrorList', data)
      this.$axiox.get(url).then(msg => {
        this.myErroerList = msg.datas || []
      })
    },
    //  下载
    confirmExport (item) {
      let that = this
      let url = ''
      that.uploadMdoel = 0
      var xmlResquest = new XMLHttpRequest()
      url = this.$baseUrlConfig.baseUrl + '/api/File/DownLoadBaseInfo?itemid=' + item.id
      xmlResquest.open('GET', url, true)
      xmlResquest.onprogress = function (e) {
        var percent = e.loaded / e.total
        that.uploadMdoel = parseInt(percent * 100)// progress 在data中定义的全局变量，显示的进度
        // console.log(that.uploadPercent)
        that.upName = item.lastFileName
        that.showModel4 = true
      }
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.localStorage.getItem('gskToken'))
      xmlResquest.setRequestHeader('Ocp-Apim-Subscription-Key', this.$baseUrlConfig.ocpKey)
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var content = xmlResquest.response
        if (content.type) {
          if (content.type.indexOf('json') >= 0) {
            that.$commonJs.alertTips({
              type: 'error',
              title: '失败',
              content: '暂无数据',
              stayTime: 5
            })
            that.showModel4 = false
            return
          }
        }
        that.$commonJs.addLog('下载', '数据上传', '', item.lastFileName)
        var elink = document.createElement('a')
        elink.download = item.lastFileName
        elink.style.display = 'none'
        var blob = new Blob([content])
        if (that.$IENum === 11) {
          window.navigator.msSaveOrOpenBlob(blob, name + '.xls')
        } else {
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          document.body.removeChild(elink)
        }
        that.showModel4 = false
      }
      xmlResquest.send()
    },
    downEorFile () {
      let that = this
      let upName = that.formEro.formEroFileName
      let url = ''
      var xmlResquest = new XMLHttpRequest()
      url = this.$baseUrlConfig.baseUrl + '/api/File/DownloadErrorList?hisid=' + this.formEro.formEroId
      xmlResquest.open('GET', url, true)
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.localStorage.getItem('gskToken'))
      xmlResquest.setRequestHeader('Ocp-Apim-Subscription-Key', this.$baseUrlConfig.ocpKey)
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var content = xmlResquest.response
        if (content.type) {
          if (content.type.indexOf('json') >= 0) {
            that.showModel4 = false
            that.$commonJs.alertTips({
              type: 'error',
              title: '失败',
              content: '暂无数据',
              stayTime: 5
            })
            return
          }
        }
        var elink = document.createElement('a')
        elink.download = upName
        elink.style.display = 'none'
        var blob = new Blob([content])
        if (that.$IENum === 11) {
          window.navigator.msSaveOrOpenBlob(blob, name + '.xls')
        } else {
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          document.body.removeChild(elink)
        }
      }
      xmlResquest.send()
    },
    coverGif () {
      if (!document.getElementById('loadingGif')) {
        let dom = document.createElement('div')
        dom.id = 'loadingGif'
        let html = '<img src="' + avatar + '" height="144" width="192"/>'
        dom.innerHTML = html
        document.getElementById('app').appendChild(dom)
      }
    },
    disCover () {
      if (document.getElementById('loadingGif')) {
        document.getElementById('app').removeChild(document.getElementById('loadingGif'))
      }
    }
  }
}
</script>
<style scoped>
.icon-upload{
  color:#44D196;
  font-size:60px;
}
.up01{background: #44D196;width:60px;height:48px;border-radius:4px;display:inline-block;border-radius:10px;margin-right:5px;}
</style>



// WEBPACK FOOTER //
// src/components/pages/myDnUpload/index.vue